import React, {Component}   from 'react';
import {Panel}              from 'react-bootstrap';

import CrudComponent        from './../zynappse-crud';
import VersionCheckerSchema       from '../schema/VersionChecker.json';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';

import saveTrail            from '../../utils/saveTrail';

class VersionChecker extends Component {
  render() {
    let {
      access
    } = this.props.accessjson;

    let crudProps = {
      schema: VersionCheckerSchema,
      access: access,
      saveTrail: saveTrail
    };

    return (
      <Panel>
        <Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
          <h4>VERSION CHECKER</h4>
        </Panel.Heading>
        <Panel.Body>
          <CrudComponent {...crudProps}/>
        </Panel.Body>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
	var {accessjson} = state;

	const props = {
		accessjson
	};
	return props;
}

export default connect(mapStateToProps)(VersionChecker);



// WEBPACK FOOTER //
// ./components/VersionChecker/index.js